import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"

declare var window:any


export type DefinirDespesasInclusasParaItensOrcamentoInput = {
    identificadorItem: number
    ativado: boolean
}

export async function definirDespesasInclusasParaItemOrcamento(input: DefinirDespesasInclusasParaItensOrcamentoInput) {
    const orcamentoAtualizado = await microuniversoApi.Orcamento.definirDespesasInclusasItemOrcamento(input.ativado, input.identificadorItem, store.getState().orcamento.IdentificadorOrcamento)

    const orcamentoLegado = window.orcamentoController.model

    orcamentoLegado.atualizar(orcamentoAtualizado)
}